import { Link } from "react-router-dom";
import { KeyRound, UserCog, Store, UserPlus, UtensilsCrossed, Wrench, ShoppingBag, SprayCan, Home } from "lucide-react";
import PublicNav from "../components/PublicNav";

const HERO = "https://images.unsplash.com/photo-1572715376701-98568319fd0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwa2l0Y2hlbiUyMHByZXAlMjBjaGVmJTIwY29va2luZ3xlbnwwfHx8fDE3ODg4MDkxNDd8MA&ixlib=rb-4.1.0&q=85";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FBF8F3] relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-25"
        style={{ backgroundImage: `url(${HERO})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#FBF8F3]/70 via-[#FBF8F3]/85 to-[#FBF8F3]" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-8 py-16 sm:py-24 flex flex-col items-start">
        <div className="w-full flex justify-end mb-10 -mt-8">
          <PublicNav />
        </div>
        <div className="mb-4 flex items-center gap-1.5" data-testid="brand-logo-hero">
          <img src="/jotprep-icon.png" alt="jotprep checkmark" className="h-14 sm:h-16 w-auto rounded-2xl" />
          <img src="/jotprep-wordmark.png" alt="jotprep" className="h-10 sm:h-12 w-auto -ml-1" />
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#1A1D20] leading-tight" data-testid="landing-title">
          Every shift prepped.<br />
          <span className="text-terra-600">Every task proven.</span><br />
          Side Work made easy.<br />
          <span className="text-terra-600">Fast Track New Staff.</span>
        </h1>
        <p className="mt-5 text-base md:text-lg text-slate-500 max-w-xl">
          Great for new or current staff, field techs or anyone who needs: instant access to the task information - right in their hands
        </p>

        <div className="mt-5 flex items-center gap-5 flex-wrap" data-testid="who-its-for-row">
          {[
            { icon: UtensilsCrossed, label: "Restaurants" },
            { icon: Wrench, label: "Field Service" },
            { icon: ShoppingBag, label: "Retail" },
            { icon: SprayCan, label: "Cleaning" },
            { icon: Home, label: "House Managers" },
          ].map(({ icon: Icon, label }) => (
            <div key={label} className="flex items-center gap-1.5 text-slate-500" data-testid={`who-item-${label.toLowerCase().replace(/\s+/g, "-")}`}>
              <Icon className="w-4 h-4 text-terra-600" />
              <span className="text-xs font-medium uppercase tracking-wider">{label}</span>
            </div>
          ))}
        </div>

        <div className="mt-12 grid sm:grid-cols-2 gap-4 w-full max-w-2xl">
          <Link
            to="/kiosk"
            data-testid="staff-kiosk-button"
            className="group p-6 rounded-2xl bg-terra-500 text-white hover:bg-terra-600 transition-colors"
          >
            <KeyRound className="w-8 h-8 mb-3" />
            <div className="font-display font-bold text-xl">Staff Kiosk</div>
            <div className="text-sm opacity-80 mt-1">Clock in with your business code & 4-digit PIN</div>
          </Link>

          <Link
            to="/login"
            data-testid="manager-login-link"
            className="group p-6 rounded-2xl bg-white/90 backdrop-blur border border-[#E4DDD3] hover:border-terra-400/50 transition-colors"
          >
            <UserCog className="w-8 h-8 mb-3 text-terra-600" />
            <div className="font-display font-bold text-xl text-[#1A1D20]">Manager Login</div>
            <div className="text-sm text-slate-500 mt-1">Dashboards, templates & live status</div>
          </Link>

          <Link
            to="/create-restaurant"
            data-testid="create-restaurant-button"
            className="group p-6 rounded-2xl bg-white/90 backdrop-blur border border-[#E4DDD3] hover:border-terra-400/50 transition-colors"
          >
            <Store className="w-8 h-8 mb-3 text-terra-600" />
            <div className="font-display font-bold text-xl text-[#1A1D20]">Create Business</div>
            <div className="text-sm text-slate-500 mt-1">Restaurant or any other business for task checklist</div>
          </Link>

          <Link
            to="/join"
            data-testid="join-restaurant-button"
            className="group p-6 rounded-2xl bg-white/90 backdrop-blur border border-[#E4DDD3] hover:border-terra-400/50 transition-colors"
          >
            <UserPlus className="w-8 h-8 mb-3 text-terra-600" />
            <div className="font-display font-bold text-xl text-[#1A1D20]">Join a Business</div>
            <div className="text-sm text-slate-500 mt-1">New staff? Register with your join code</div>
          </Link>
        </div>
      </div>
    </div>
  );
}
